var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"alert",attrs:{"title":_vm.error,"data-test":"error"}},[(_vm.heading)?_c('strong',[_vm._v(_vm._s(_vm.heading)+": ")]):_vm._e(),_vm._v(_vm._s(_vm.error))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }